module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"enterTheAnswer":"Enter your answer","requiredField":"This field is required"}}')
  delete Component.options._Ctor
}
